import Joi from '@hapi/joi'

export const taskSchemaObject = {

    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group Required`,
        "any.required": `Group Required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operation Entity").messages({
        "any.invalid": `Operation Entity Required`,
        "any.required": `Operation Entity Required`
    }),
    estateTaskID: Joi.number().invalid(0).required().label("Task Type").messages({
        "any.invalid": `Task Type Required`,
        "any.required": `Task Type Required`
    }),
    taskCode: Joi.string().required().label("Task Code").regex(/^(?!\s*$).+/).messages({
        "string.empty": `Task Code required`,
        "string.pattern.base": `Please enter valid task code`,
    }),
    taskName: Joi.string().required().label("Task Name").regex(/^(?!\s*$).+/).messages({
        "string.empty": `Task Name required`,
        "string.pattern.base": `Please enter valid task name`,
    }),
    taskDescription: Joi.string().required().label("Task Description").regex(/^(?!\s*$).+/).messages({
        "string.empty": `Task Description required`,
        "string.pattern.base": `Please enter valid task description`,
    }),
    measuringUnit: Joi.string().label("Measuring Unit").regex(/^(?!\s*$).+/),
    isActive: Joi.boolean().label("Active")
}














